import { ComputeFieldComponent } from "../computeFields";
import { Exhibition } from "../types";
import { t } from "i18next";
import { SeparatedList } from "./shared/utils";

export const ExhibitionSummaryCF: ComputeFieldComponent<
  Pick<
    Exhibition,
    | "expositionsDescriptionTitreIncertain"
    | "expositionsDescriptionTitre"
    | "expositionsDescriptionTitreDOrigine"
    | "expositionsDescriptionDatesChoixInconnues"
    | "expositionsDescriptionDatesChoixIncertaines"
    | "expositionsDescriptionDates"
    | "expositionsDescriptionLieuIncertain"
    | "expositionsDescriptionLieu"
    | "expositionsDescriptionCityIncertain"
    | "expositionsDescriptionVille"
    | "expositionsDescriptionCountryIncertain"
    | "expositionsDescriptionPays"
    | "expositionsDescriptionTexteSupplementaire"
  >
> = ({ input, language, ...props }) => {
  const list = (
    <SeparatedList
      {...props}
      language={language}
      input={[
        input.expositionsDescriptionTitreIncertain ? (
          `[${input.expositionsDescriptionTitre}]`
        ) : (
          <i>{input.expositionsDescriptionTitre}</i>
        ),
        input.expositionsDescriptionTitreDOrigine && (
          <>({input.expositionsDescriptionTitreDOrigine})</>
        ),
        input.expositionsDescriptionDatesChoixInconnues
          ? t("computeField.sansDateAbbrege", { lng: language })
          : input.expositionsDescriptionDatesChoixIncertaines
            ? `[${input.expositionsDescriptionDates}]`
            : input.expositionsDescriptionDates,
        input.expositionsDescriptionLieuIncertain
          ? `[${input.expositionsDescriptionLieu}]`
          : input.expositionsDescriptionLieu,
        input.expositionsDescriptionCityIncertain
          ? `[${input.expositionsDescriptionVille}]`
          : input.expositionsDescriptionVille,
        input.expositionsDescriptionCountryIncertain
          ? `[${input.expositionsDescriptionPays}]`
          : input.expositionsDescriptionPays,
      ]}
    />
  );

  const additionalText = input.expositionsDescriptionTexteSupplementaire && (
    <> {input.expositionsDescriptionTexteSupplementaire}</>
  );

  return (
    <>
      {list}
      {additionalText}
    </>
  );
};
